export default "https://fenwan.cdn.bcebos.com/gamecenter/static/game/assets/imgs/vip-guide-bg.eb86c8bb.png";